import React from "react";
import { mergeThemes, Provider as FluentUIThemeProvider, } from "@fluentui/react-northstar";
import { teamsNextVariableAssignments, themes } from "../../lib/withTheme";
import { TeamsTheme } from "../../themes";
import { Surface } from "../../types/types";
var getLocalTheme = function (themeName, surface) {
    return {
        componentStyles: {
            Dropdown: {
                container: function () { return ({
                    backgroundColor: "var(--input-background)",
                    "&:hover": { backgroundColor: "var(--input-background)" },
                    "&:focus": { backgroundColor: "var(--input-background)" },
                }); },
            },
            Input: {
                input: function () { return ({ backgroundColor: "var(--input-background)" }); },
            },
            TextArea: {
                root: function () { return ({ backgroundColor: "var(--input-background)" }); },
            },
        },
    };
};
export var FormTheme = function (_a) {
    var _b;
    var globalTheme = _a.globalTheme, children = _a.children, surface = _a.surface;
    var mainTheme = ((_b = globalTheme.siteVariables) === null || _b === void 0 ? void 0 : _b.theme) ? globalTheme
        : themes.teamsTheme;
    var cssProperties = (function () {
        switch (surface) {
            case Surface.base:
                return {
                    background: "transparent",
                    "--surface-background": globalTheme.siteVariables.colorScheme.default.background2,
                    "--shadow-background": globalTheme.siteVariables.colorScheme.default.border2,
                    "--input-background": globalTheme.siteVariables.colorScheme.default.background,
                };
            case Surface.raised:
                return {
                    background: "transparent",
                    "--surface-background": "transparent",
                    "--shadow-background": globalTheme.siteVariables.colorScheme.default.border1,
                    "--input-background": (function () {
                        var _a;
                        switch ((_a = mainTheme.siteVariables) === null || _a === void 0 ? void 0 : _a.theme) {
                            case TeamsTheme.Dark:
                                return globalTheme.siteVariables.colorScheme.default
                                    .background1;
                            default:
                                return globalTheme.siteVariables.colorScheme.default
                                    .background2;
                        }
                    })(),
                };
        }
    })();
    return (React.createElement(FluentUIThemeProvider, { theme: mergeThemes(mainTheme, teamsNextVariableAssignments, getLocalTheme(globalTheme.siteVariables.theme, surface)), styles: cssProperties }, children));
};
//# sourceMappingURL=FormTheme.js.map